export const variables = {
    props: {
        MuiButtonBase: {
            disableRipple: true,
        },
    },
    typography: {
        useNextVariants: true,
        fontFamily: '"Source Sans Pro", sans-serif !important',
        color: '#666666',
        body1: {
            fontSize: 16,
        },
    },
    variables: {
        navHeight: '70px',
        button: {
            borderRadius: '23px',
        },
        buttonOutlined: {
            borderRadius: '19px',
        },
        paper: {
            borderRadius: '8px',
        },
        input: {
            borderRadius: '4px',
        },
        checkbox: {
            borderRadius: '4px',
        },
        logo: {
            dashboard: {
                desktop: {
                    height: '32px',
                },
            },
        },
    },
    palette: {
        primary: {
            main: '#23B6EC',
        },
        secondary: {
            main: '#222222',
        },
        background: {
            paper: '#ffffff',
            default: '#F4F6F9',
        },
        light: {
            header: {
                background: {
                    main: '#FFFFFF',
                },
                text: {
                    main: '#222222',
                    secondary: '#666666',
                },
                border: '#DDDDDD',
            },
        },
    },
    color: {
        primary: {
            main: '#23B6EC ',
            grey: '#E3E3E3',
            white: '#FFFFFF',
            black: '#000',
            light: '#E9F8FF',
        },
        secondary: {
            main: '#FFFFFF',
            grey: '#F4F6F9',
        },
        text: {
            main: '#222222',
            secondary: '#666666',
            placeholder: '#ADADAD',
            light: '#FFFFFF',
            dark: '#000',
            active: '#23B6EC',
            muted: '#999999',
            landing: '#222222',
            landingTitle: '#FFFFFF',
            landingBottomTitle: '#FFFFFF',
            landingBottomWeight: 400,
        },
        input: {
            disabled: '#F6F6F6',
            disabledText: '#222222',
            disabledOpacity: 0.9,
            daisabledFillColor: 'unset',
            daisabledFontWeight: 400,
        },
        link: {
            main: '#222222',
            secondary: '#666666',
            active: '#23B6EC',
        },
        border: {
            main: '#DDDDDD',
            secondary: '#666666',
            additional: '#E3E3E3',
            active: '#23B6EC',
        },
        button: {
            main: '#60D956',
            disabled: '#60d9564d',
            secondary: '#F6F6F6',
            mainHover: '#54be4c',
            secondaryHover: '#e9e9e9',
            outlinedHover: '#e9f8ff',
            text: '#ffffff',
            textSecondary: '#222222',
            radioBorder: '#E5E6E7',
            radioActive: '#23B6EC',
            border: '#DDDDDD',
            borderActive: '#23B6EC',
            boxHover: '#F2FCFF',
        },
        backButton: {
            main: 'rgba(136,136,136,0.5)',
            mainHover: 'rgba(102,102,102,0.50)',
            text: '#ffffff',
        },
        buttonContained: {
            hover: '#ceedfa',
            disabled: '#60D956',
            disabledText: '#FFFFFF',
        },
        buttonContainedSecondary: {
            main: '#e9f8ff',
            mainText: '#23B6EC',
            disabled: '#e9f8ff',
            disabledText: '#009FEB',
            hover: '#ceedfa',
        },
        checkbox: {
            active: '#e9f8ff',
            borderActive: '#e9f8ff',
            border: '#EEEEEE',
        },
        status: {
            Pending: '#999999',
            WaitingForApproval: '#999999',
            Processing: '#23B6EC',
            Finished: '#60D956',
            Canceled: '#DD3333',
            CancellationRequested: '#DD3333',
            Failed: '#222222',
            Reverted: '#F6BB2B',
        },
        bg: {
            main: '#EEFAFE',
            canceled: 'rgba(221, 51, 51, 0.08)',
        },
        close: {
            main: '#222222',
        },
        grey: {
            main: '#DDDDDD',
            secondary: '#F6F6F6',
        },
        success: {
            main: '#60D956',
            hover: '#5dac57',
        },
        error: {
            main: '#FA5849',
        },
        warning: {
            main: '#ed6c02',
        },
        background: {
            default: '#F4F6F9',
            secondary: '#fff',
        },
        nav: {
            mainHover: 'rgba(135, 142, 159, 0.1)',
        },
        stepper: {
            activeLine: '#60D956',
            completedLine: '#60D956',
        },
    },
}

export const styledComponentsTheme = {
    props: { ...variables.props },
    typography: { ...variables.typography },
    variables: { ...variables.variables },
    palette: { ...variables.palette },
    color: { ...variables.color },
}
